(function ($) {
    var tabletWidth = 767;
    var openClass = "navigation__is-open";
    var $nav = $(".js-navigation");
    var $overlay = $(".js-navigation__overlay");
    // var navIsVisible = false;

    var isMobile = window.innerWidth <= tabletWidth;
    if (isMobile) {
        $nav.addClass("is-mobile");
    }

    // window.onresize = function (e) {
    //     if (window.innerWidth >= tabletWidth && isMobile) {
    //         $("body").removeClass(openClass);
    //         $nav.removeClass("is-mobile");
    //         isMobile = false;
    //     } else if (window.innerWidth < tabletWidth && !isMobile) {
    //         $nav.addClass("is-mobile");
    //         isMobile = true;
    //     }
    // };
    $(window).resize(
        function (e) {
            if (window.innerWidth >= tabletWidth && isMobile) {
                $("body").removeClass(openClass);
                $nav.removeClass("is-mobile");
                isMobile = false;
            } else if (window.innerWidth < tabletWidth && !isMobile) {
                $nav.addClass("is-mobile");
                isMobile = true;
            }
        }
    );

    $(".js-navigation__toggle").click(function (e) {
        $("body").toggleClass(openClass);
        $overlay.toggleClass("is-visible");
        e.stopPropagation();
        // console.log("toggle target" + e.target);
    });

    $overlay.on('touchstart click', function (e) {
        if ($(this).hasClass("is-visible")) {
            $("body").removeClass(openClass);
            $overlay.removeClass("is-visible");
        }
    });
})(jQuery);


// WEBPACK FOOTER //
// ./common.blocks/navigation/navigation.js